export default __webpack_public_path__ + "static/media/impacto.f6fb48a7.png";